export default {
  // 登录界面标题
  LOGIN_TITLE: 'LOGIN_TILE',
  // 登录界面子标题
  LOGIN_SUB_TITLE: 'LOGIN_SUB_TITLE',
  // 登录界面表单标题
  LOGIN_FORM_TITLE: 'LOGIN_FORM_TITLE',
  // 卡号输入框的placeholder
  ADA_TEXTBOX_PLACEHOLDER: 'ADA_TEXTBOX_PLACEHOLDER',
  // 手机号输入框的placeholder
  PHONE_NUMBER_TEXTBOX_PLACEHOLDER: 'PHONE_NUMBER_TEXTBOX_PLACEHOLDER',
  // 验证码输入框的placeholder
  CAPTCHA_TEXTBOX_PLACEHOLDER: 'CAPTCHA_TEXTBOX_PLACEHOLDER',
  // 获取验证码按钮的值
  FETCH_CAPTCHA_BUTTON: 'FETCH_CAPTCHA_BUTTON',
  // 用户协议内容
  TERM_DESCRIPTION: 'TERM_DESCRIPTION',
  // 用户协议内容-用户协议
  TERM_DESCRIPTION_USER_AGREEMENT: 'TERM_DESCRIPTION_USER_AGREEMENT',
  // 用户协议内容-隐私政策
  TERM_DESCRIPTION_PRIVACY_STRATEGY: 'TERM_DESCRIPTION_PRIVACY_STRATEGY',
  COPYRIGHT_DESCRIPTION: 'COPYRIGHT_DESCRIPTION',
  GREET_TXT: 'GREET_TXT',

  // 获取验证码按钮
  GET_CAPTCHA_BUTTON: 'GET_CAPTCHA_BUTTON',
  // 获取验证码后倒数按钮
  RE_GET_CAPTCHA_BUTTON: 'RE_GET_CAPTCHA_BUTTON',
  // 智能验证按钮
  INTELLIGENT_VERIFICATION_BUTTON: 'INTELLIGENT_VERIFICATION_BUTTON',
  // 登录按钮
  LOGIN_BUTTON: 'LOGIN_BUTTON',
  // 关闭按钮
  CLOSE_BUTTON: 'CLOSE_BUTTON',
  // 退出按钮
  LOGOUT_BUTTON: 'LOGOUT_BUTTON',

  // 验证码发送后提示
  CAPTCHA_HAS_BEEN_SENT_TIPS: 'CAPTCHA_HAS_BEEN_SENT_TIPS',
  START_INTELLIGENT_VERIFICATION_TIPS: 'START_INTELLIGENT_VERIFICATION_TIPS',
  SUCCESS_INTELLIGENT_VERIFICATION_TIPS: 'SUCCESS_INTELLIGENT_VERIFICATION_TIPS',
  FAIL_INTELLIGENT_VERIFICATION_TIPS: 'FAIL_INTELLIGENT_VERIFICATION_TIPS',
  SCANING_INTELLIGENT_VERIFICATION_TIPS: 'SCANING_INTELLIGENT_VERIFICATION_TIPS',

  NETWORK_ERROR: 'NETWORK_ERROR',
  TERM_REQUIRED_ERROR: 'TERM_REQUIRED_ERROR',
  CAPTCHA_REQUIRED_ERROR: 'CAPTCHA_REQUIRED_ERROR',
  ADA_NUMBER_REQUIRED_ERROR: 'ADA_NUMBER_REQUIRED_ERROR',
  PHONE_NUMBER_REQUIRED_ERROR: 'PHONE_NUMBER_REQUIRED_ERROR',
};
  